import { render, staticRenderFns } from "./Sneakers.vue?vue&type=template&id=3c2e5f5f&"
import script from "./Sneakers.vue?vue&type=script&lang=js&"
export * from "./Sneakers.vue?vue&type=script&lang=js&"
import style0 from "./Sneakers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports